<div data-testid="order-internal-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "order.internal.title" | translate }}
  </h2>

  <app-search-form
    data-testid="order-internal-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        (primaryButtonClick)="onCreateOrder()"
        (secondaryButtonClick)="onColumnConfigClick($event)"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter with Create Order Button -->
  <div class="mb-2 flex-table-header">
    <app-status-filter
      [statusOptions]="statusOptions"
      (statusChange)="onStatusChange($event)"
    ></app-status-filter>
  </div>

  <!-- Advanced Data Table with column selector and frozen actions -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="order-internal-table"
      #advancedTable
      [dataSource]="orders()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      [hasCheckColumn]="false"
      (selectionChange)="onSelectionChange($event)"
      [showInternalColumnConfigButton]="false"
    >
    <ng-template #customTemplate let-value let-column="column" let-rowData="rowData">
      @if (column.template === "operationTimeTemplate") {
        <span class="text-xs text-gray-600 flex items-center justify-center">
          {{ formatDateTime(value) }}
        </span>
      } @else if (column.template === "currencyTemplate") {
        <span class="text-xs text-gray-600 flex items-center justify-end">
          {{ formatCurrency(value) }}
        </span>
      } @else if (column.template === "statusTemplate") {
        <span class="flex items-center justify-center">
          <p-tag
            data-testid="order-internal-status-tag"
            [value]="getStatusDisplayText(column.prop, value) | translate"
            [severity]="getStatusSeverity(column.prop, value)"
            styleClass="status-tag"
            [ngStyle]="getStatusStyle(column.prop, value)"
            [pTooltip]="getStatusTooltip(column.prop, value) | translate"
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </span>
      } @else if (column.prop === "isGift") {
        <p-tag
          data-testid="order-internal-gift-status-tag"
          [value]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          [severity]="value ? 'success' : 'danger'"
          styleClass="status-tag"
          [pTooltip]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      } @else if (column.template === "stockHoldCategoryTemplate") {
        <span class="text-xs text-gray-600">
          {{ getStockHoldCategoryLabel(rowData.stockHoldCategory) }}
        </span>
      } @else if (column.template === "stockHoldExpiryTemplate") {
        @if (
          hasStockHoldExpiryDisplay(
            rowData.stockHoldExpiryTime,
            rowData.failureReasonDescription
          )
        ) {
          <p-tag
            [value]="
              getStockHoldExpiryLabel(
                rowData.stockHoldExpiryTime,
                rowData.failureReasonDescription
              )
            "
            [severity]="
              getStockHoldExpirySeverity(
                rowData.stockHoldExpiryTime,
                rowData.failureReasonDescription
              )
            "
            styleClass="status-tag"
          />
        } @else {
          <span class="text-xs text-gray-500">
            {{ 'stock_hold_timeout.order.no_limit' | translate }}
          </span>
        }
      } @else if (column.template === "failureReasonTemplate") {
        @if (rowData.failureReasonDescription) {
          <p-tag
            [value]="getFailureReasonLabel(rowData.failureReasonDescription)"
            [severity]="
              rowData.failureReasonDescription === 'STOCK_HOLD_TIMEOUT'
                ? 'danger'
                : 'secondary'
            "
            styleClass="status-tag"
          />
        }
      } @else {
        {{ value }}
      }
    </ng-template>
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center">
        @if (canRead()) {
          <span
            [attr.data-testid]="'order-internal-action-view-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            (click)="onView(rowData)"
            class="action-link action-view cursor-pointer"
          >
            {{ "common.actions.view" | translate }}
          </span>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>
